import { render, staticRenderFns } from "./sublessorCompanySub.vue?vue&type=template&id=22c9e31a&scoped=true"
import script from "./sublessorCompanySub.vue?vue&type=script&lang=js"
export * from "./sublessorCompanySub.vue?vue&type=script&lang=js"
import style0 from "./sublessorCompanySub.vue?vue&type=style&index=0&id=22c9e31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c9e31a",
  null
  
)

export default component.exports